import { observable, action, computed } from 'mobx';

export default class MsgStore {
	@observable _info: any = '';
	@observable _error: any = '';

	constructor() {}

	@action
	clear() {
		this._info = '';
		this._error = '';
	}

	@action
	setInfo(infoMsg: string) {
		this.clear();
		this._info = infoMsg;
	}

	@action
	setError(error: any) {
		this.clear();
		this._error = error;
	}

	@computed
	get info(): string {
		return this._info;
	}

	@computed
	get errors(): Array<string> {
		if (!this._error) {
			return null;
		} else if (typeof this._error === 'string') {
			return [this._error];
		} else if (Array.isArray(this._error)) {
			return this._error;
		} else if (
			typeof this._error === 'object' &&
			(this._error.name === 'Error' ||
				this._error.name === 'TypeError' ||
				this._error.name === 'ReferenceError')
		) {
			return [this._error.message];
		} else if (typeof this._error === 'object' && this._error.name === 'ValidationError') {
			return this._error.errors ? this._error.errors : [this._error.message];
		} else {
			return [this.toString()];
		}
	}
}



// WEBPACK FOOTER //
// ./src/stores/MsgStore.js